import axios from "axios";

const httpClient = axios.create({
  // baseURL: "http://44.195.125.80:9734/api/v1",
  // baseURL: "http://35.178.56.111/api/v1",

  baseURL: "https://weprice1.com/api/v1/",

  // baseURL: "http://172.16.100.219:9734/api/v1", //server
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request interceptor
httpClient.interceptors.request.use(
  (request) => {
    // Do something with the request config (e.g., add headers, authentication token)
    // For example:
    // request.headers['Authorization'] = 'Bearer sfsdfsdf';
    let token = window.localStorage.getItem("ProviderToken");
    // if (token) {
    //   token = JSON.parse(token);
    // }

    request.headers["Authorization"] = `Bearer ${token}`;

    // If the request data is FormData, remove Content-Type header
    // to let the browser set it automatically with the boundary
    if (request.data instanceof FormData) {
      delete request.headers["Content-Type"];
    }

    // console.log("token => ", `Bearer ${token}`);
    // console.log("request interceptors", token);

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
httpClient.interceptors.response.use(
  (response) => {
    // Check if response is HTML instead of JSON
    const contentType = response.headers["content-type"] || "";
    if (contentType.includes("text/html")) {
      console.error(
        "Server returned HTML instead of JSON. This usually means the API endpoint is incorrect or the server is down.",
      );
      return Promise.reject({
        response: {
          status: 500,
          data: {
            message:
              "Server error: Received HTML response instead of JSON. Please check the API endpoint.",
          },
        },
      });
    }
    return response;
  },
  (error) => {
    // Handle network errors (no response from server)
    if (!error.response) {
      console.error("Network error or server is unreachable:", error.message);
      return Promise.reject({
        response: {
          status: 0,
          data: {
            message:
              "Network error: Unable to reach the server. Please check your internet connection.",
          },
        },
      });
    }

    // Handle unauthorized/invalid token errors
    if (error.response) {
      const status = error.response.status;
      const contentType = error.response.headers["content-type"] || "";

      // Check if response is HTML (error page) instead of JSON
      if (contentType.includes("text/html")) {
        console.error(
          "Server returned HTML error page instead of JSON response",
        );
        return Promise.reject({
          response: {
            status: status || 500,
            data: {
              message: `Server error (${status}): The server returned an HTML page instead of a JSON response. Please check the API endpoint configuration.`,
            },
          },
        });
      }

      // Extract message from response data
      let message = "";
      if (typeof error.response.data === "string") {
        // If data is a string, try to parse it or use it directly
        try {
          const parsed = JSON.parse(error.response.data);
          message = parsed.message || parsed.error || "";
        } catch (e) {
          message = error.response.data;
        }
      } else if (
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        message =
          error.response.data?.message || error.response.data?.error || "";
      }

      // Handle 403 - Account disabled by admin (show popup, don't redirect yet)
      if (status === 403) {
        localStorage.removeItem("ProviderToken");
        localStorage.removeItem("ProviderName");
        localStorage.removeItem("ProviderEmail");
        localStorage.removeItem("ProviderSetup");
        localStorage.removeItem("ProviderFirebaseId");
        window.dispatchEvent(new CustomEvent("accountDisabled"));
        return Promise.reject(error);
      }

      // Handle unauthorized (401) or invalid token errors
      if (
        status === 401 ||
        message.toLowerCase().includes("unauthorized") ||
        message.toLowerCase().includes("invalid token") ||
        message.toLowerCase().includes("token expired") ||
        message.toLowerCase().includes("token is invalid") ||
        message.toLowerCase().includes("authentication failed")
      ) {
        sessionStorage.setItem(
          "tokenExpiredMessage",
          "Your session has expired. Please login again.",
        );

        localStorage.removeItem("ProviderToken");
        localStorage.removeItem("ProviderName");
        localStorage.removeItem("ProviderEmail");
        localStorage.removeItem("ProviderSetup");
        localStorage.removeItem("ProviderFirebaseId");

        window.location.href = "/auth/login";
      }
    }

    // Do something with the response error (e.g., error handling, logging)
    return Promise.reject(error);
  },
);

export default httpClient;
